import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useEffect, useState } from "react";
import { FormsTable } from "./components/formsTable/formsTable";
import { useSearchForms } from "./hooks/useSearchForms";

type Props = {};

export const ConfigurationFormsPage = (prop: Props) => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [error, setError] = useState<string>("");
	const searchForms = useSearchForms({ setIsLoading, setError });

	useEffect(() => {
		searchForms();
	}, []);

	return (
		<Grid
			container
			justifyContent="center"
			alignItems="center"
			style={{ padding: "16px" }}
		>
			<Grid item md={12} xs={12} style={{ margin: 0 }}>
				<Typography
					variant="h5"
					style={{ margin: "0 0 20px", fontWeight: 600 }}
				>
					Forms Settings
				</Typography>
				<Paper
					elevation={1}
					style={{
						width: "100%",
						padding: "10px 0 20px",
						borderRadius: "0.75rem",
					}}
				>
					<FormsTable
						isLoading={isLoading}
						searchForms={searchForms}
						error={error}
						setError={setError}
					/>
				</Paper>
			</Grid>
		</Grid>
	);
};
